module.exports = __webpack_public_path__ + "img/peru-patria-segura.8ca6a773.png";